import CycleHarvest from './CycleHarvest';

export default CycleHarvest;
